import useDocumentTitle from '@/components/ui/common/document-title';
import FacilityScheduleCalendarView from './calendar';

const FacilitySchedule = () => {
  useDocumentTitle("Facilities Schedule");

  return (
    <div className="w-full h-full">
      <FacilityScheduleCalendarView />
    </div>
  );
}

export default FacilitySchedule;